// news-brief 动画：当前头条索引。
import type { SceneData } from '../../api/types'
import type { NewsData } from './types'

export function newsIdx(d: SceneData, time: number): number {
  const data = d as unknown as NewsData
  const interval = 5
  const idx = Math.floor(time / interval)
  return idx < (data.headlines?.length ?? 0) ? idx : 0
}
